import { Navigate, useLocation, useSubmission } from '@solidjs/router';
import { Form, Button, Errors, HiddenFields } from '@troon/ui';
import { createEffect, Switch, Match } from 'solid-js';
import { clientAction } from '@troon/api-client';
import { useTrackEvent } from '@troon/analytics';
import { useAuthStore } from '../flow';

export function FirstLogin() {
	const [store, setStore] = useAuthStore();
	const location = useLocation();
	const trackEvent = useTrackEvent();

	const resetSubmission = useSubmission(resetPassword);

	createEffect(() => {
		if (resetSubmission.pending) {
			trackEvent('passwordResetCode');
		}
		if (resetSubmission.result) {
			setStore({ flow: 'forgotPassword', step: '/auth/reset' });
			resetSubmission.clear();
		}
	});

	return (
		<Switch>
			<Match when={!store.data.email}>
				<Navigate href={`/auth${location.search}`} />
			</Match>
			<Match when={true}>
				<Form action={resetPassword} method="post" suppressRequired>
					<HiddenFields data={{ emailOrRewardsId: store.data.email, redirectUrl: store.redirect }} />

					<p>Your password has expired. Please reset it to continue.</p>

					<Errors />

					<Button disabled={resetSubmission.pending} type="submit">
						Reset password
					</Button>
				</Form>
			</Match>
		</Switch>
	);
}

const resetPassword = clientAction('post', '/v0/auth/forgot-password');
